import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../shared/modules/translate/translate.service';
@Pipe({
  name: 'dateAgo',
  pure: true,
  standalone: true,
})
export class DateAgoPipe implements PipeTransform {
  constructor(private translationService: TranslateService) {}
  transform(value: any) {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29)
        // less than 30 seconds ago will show as 'Just now'
        return this.translationService.get('Just now');

      const intervals: { [key: string]: number } = {
        y: 31536000, // seconds in a year
        m: 2592000, // seconds in a month
        w: 604800, // seconds in a week
        d: 86400, // seconds in a day
        h: 3600, // seconds in an hour
        min: 60, // seconds in a minute
        s: 1, // seconds
      };
      let counter;
      for (const since in intervals) {
        counter = Math.floor(seconds / intervals[since]);
        if (counter > 0)
          return `${counter}${this.translationService.get(since)}`;
      }
    }
    return value;
  }
}
